export default [
  {
    path: '/official-20251010-main',
    component: () => import('./Page.vue'),
    meta: { title: '提现页面' },
  },
]
